import { useState } from "react";
import { CloseIcon } from "../../components/icons/Icon2";
import InputTag from "../../components/updatedComponents/FormComponents/InputTag";
import styles from "./Inventory.module.css";
import VerticalDropDown2 from "../../components/updatedComponents/FormComponents/VerticalDropDown2";
import CheckBox from "../../components/updatedComponents/FormComponents/CheckBox";
import Button from "../../components/updatedComponents/Dealers/Button";
import { CancelIcon2, TestTopAddDealerIcon } from "../../components/icons/Icon";

const CreateCustomVoucher = ({ mode, handleCloseModal }) => {
  const [data, setData] = useState({
    voucherName: "",
    customReceipt: false,
  });

  const submitForm = () => {};
  return (
    <div
      className={styles.create_custom_voucher}
      style={mode ? { backgroundColor: "#2C2E33" } : {}}
    >
      <div>
        <p style={{ color: mode && "#FFFFFF" }}> Add New Item</p>
        <div style={{ cursor: "pointer" }} onClick={handleCloseModal}>
          <CloseIcon mode={mode} />
        </div>
      </div>

      <div>
        <InputTag
          labelText={"Voucher Name"}
          padding={"8px"}
          fontSize={"12px"}
          required={true}
          placeholderType={"text"}
          maxLength={100}
          star
          value={data.itemNo}
          onChange={(e) =>
            setData({
              ...data,
              voucherName: e.target.value,
            })
          }
        />
      </div>

      <div>
        <VerticalDropDown2
          label={"Allowed Accounts"}
          star
          height={"37px"}
          fontSize={"12px"}
          padding={"6px"}
        />
      </div>

      <div>
        <InputTag
          labelText={"Minimum Product Amount"}
          padding={"8px"}
          fontSize={"12px"}
          required={true}
          placeholderType={"text"}
          maxLength={100}
          star
          value={data.itemNo}
          onChange={(e) =>
            setData({
              ...data,
              voucherName: e.target.value,
            })
          }
        />
      </div>

      <div id={styles.checkbox}>
        <p style={{ color: mode && "#ffffff" }}>Custom Receipt</p>

        <CheckBox
          checked={!!data.customReceipt}
          handleChange={(e) =>
            setData({
              ...data,
              customReceipt: e.target.checked,
            })
          }
        />
      </div>

      {!!data.customReceipt && (
        <div>
          <InputTag
            labelText={"Order Prefix"}
            padding={"8px"}
            fontSize={"12px"}
            required={!!data.customReceipt}
            placeholderType={"text"}
            maxLength={5}
            star
            value={data.prefix}
            onChange={(e) =>
              setData({
                ...data,
                prefix: e.target.value,
              })
            }
          />
          <InputTag
            labelText={"Receipt Prefix"}
            padding={"8px"}
            fontSize={"12px"}
            required={!!data.customReceipt}
            placeholderType={"text"}
            maxLength={5}
            star
            value={data.prefix}
            onChange={(e) =>
              setData({
                ...data,
                prefix: e.target.value,
              })
            }
          />
        </div>
      )}

      <div>
        <Button
          buttonBgColor={"#000"}
          buttonText={"CANCEL"}
          buttonTextColor={"#fff"}
          buttonIcon={<CancelIcon2 />}
          buttonClick={() => {
            handleCloseModal();
          }}
        />

        <Button
          buttonBgColor={"#4164E3"}
          buttonText={"ADD"}
          buttonTextColor={"#fff"}
          buttonIcon={<TestTopAddDealerIcon />}
          buttonClick={(e) => submitForm(e)}
        />
      </div>
    </div>
  );
};

export default CreateCustomVoucher;
